import React, { FC } from 'react';
import { WebpagePreview } from 'components/WebpagePreview/WebpagePreview';
import { useAppStore } from 'stores/appStore';

export const SelectNameStepPreview: FC = () => {
  const storeName = useAppStore((state) => state.storeName);

  return <WebpagePreview skeletonEnabled={false} headerTitle={storeName} />;
};
